import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import MathquillUIElement from 'mathquill-ui';

import stringUtils from '../../../../../../../qti/utils/StringUtils';
import { t } from '../../../../../../../services/i18nService';
import a11yIIBScreenReaderService, { A11yForIIBScreenReaderIteration } from '../../../../../../../services/a11yIIBScreenReaderService';

import styles from '../../../../mathWorkingInteraction/mathWorking.scss';

const MATH_INPUT_FIELD_WIDTH_MULTIPLIER = 6.70;
const MAX_CONTENT_WIDTH = 700;

class MathEntryInput extends React.Component {
    static propTypes = {
        mathSymbolPalettePreset: PropTypes.object,
        defaultValue: PropTypes.string.isRequired,
        isReadOnly: PropTypes.bool,
        model: PropTypes.object.isRequired, // model taken from responseModels related to this interaction
        size: PropTypes.number.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = { isTooWide: false };
    }

    componentDidMount() {
        this.initMathquill();
    }

    componentDidUpdate(prevProps) {
        if (this.props.isReadOnly !== prevProps.isReadOnly) {
            ReactDOM.unmountComponentAtNode(this.mathQuillTargetElement);
            this.initMathquill();
        }
    }

    componentWillUnmount() {
        if (this.mathQuillTargetElement) {
            ReactDOM.unmountComponentAtNode(this.mathQuillTargetElement);
        }
    }

    initMathquill = () => {
        const { defaultValue, model, mathSymbolPalettePreset } = this.props;
        const isA11yIIBScreenReaderSupportedV3 = a11yIIBScreenReaderService
            .isA11yIterationForIIBScreenReaderSupported(A11yForIIBScreenReaderIteration.v3);

        ReactDOM.render(
            <MathquillUIElement
                key={`mathquill-${model.identifier}`}
                triggerOnClick
                disableMenuCache
                id={this.getMathEditableId()}
                initiallyActive
                symbolsToHide={['\\degree']}
                wrapper={this.mathQuillTargetElement}
                mathquillText={defaultValue}
                onInstanceReady={this.onMathquillUIElementInstanceReady}
                mathEditableChangeCallback={this.onMathEditableChange}
                menuData={mathSymbolPalettePreset}
                isA11yIIBScreenReaderEnabled={isA11yIIBScreenReaderSupportedV3}
            />,
            this.mathQuillTargetElement
        );
    };

    setValue = (value) => {
        if (this.mathquillUIElement) {
            this.mathquillUIElement.setMathText(value);
        }
    };

    getValue = () => {
        return this.mathquillUIElement ? this.mathquillUIElement.getLatex() : '';
    };

    getRenderedContentWidth = () => {
        return this.mathquillUIElement ? this.mathquillUIElement.getRenderedContentWidth() : 0;
    };

    getMathEditableId = () => {
        if (!this.mathEditableId) {
            this.mathEditableId = stringUtils.getUID();
        }

        return this.mathEditableId;
    };

    setMathInputSize = () => {
        const { size } = this.props;
        let inputSize = size;
        inputSize = inputSize ? `${inputSize * MATH_INPUT_FIELD_WIDTH_MULTIPLIER}px` : 'initial';

        const editableElement = this.mathQuillTargetElement.querySelector('.mathquill-editable');
        if (editableElement) {
            editableElement.style.width = inputSize;
        }
    };

    onMathquillUIElementInstanceReady = (instance) => {
        this.mathquillUIElement = instance;
        this.setMathInputSize();
    };

    onMathEditableChange = () => {
        const width = this.getRenderedContentWidth();
        this.setState({ isTooWide: width > MAX_CONTENT_WIDTH });
    };

    render() {
        const { isTooWide } = this.state;

        const rootClassNames = `interaction mathquill-outer-wrapper ${isTooWide ? styles.isTooWide : ''}`;
        return (
            <span className={rootClassNames}>
                {
                    isTooWide ?
                        <span className={styles.message}>
                            {t('interactions.mathWorking.tooLongWarning')}
                        </span> : null
                }
                <span className="mathquill-ui-wrapper mathquill-ui" ref={(div) => { this.mathQuillTargetElement = div; }} />
            </span>
        );
    }
}

export default MathEntryInput;
